<template>
    <Bar :data="chartData" :options="chartOptions" />
</template>

<script>
import { Bar } from "vue-chartjs";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
} from "chart.js";
import { formatTimeFromMs } from "@/utils/timeFormatUtils";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

function msToHours(ms) {
    return (ms || 0) / 3600000;
}

function hoursTickToLabel(value) {
    if (value === 0) return "0h:0m";
    return formatTimeFromMs(value * 3600000);
}

export default {
    name: "StatisticsHoursByDayChart",
    components: { Bar },
    props: {
        series: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        regularMsList() {
            return this.series.map(
                (d) => (d.totalMs || 0) - (d.overtimeMs || 0)
            );
        },
        overtimeMsList() {
            return this.series.map((d) => d.overtimeMs || 0);
        },
        chartData() {
            return {
                labels: this.series.map((d) => d.date),
                datasets: [
                    {
                        label: "Regular",
                        backgroundColor: "#43A047",
                        borderRadius: 4,
                        stack: "hours",
                        data: this.regularMsList.map(msToHours),
                    },
                    {
                        label: "Overtime",
                        backgroundColor: "#C62828",
                        borderRadius: 4,
                        stack: "hours",
                        data: this.overtimeMsList.map(msToHours),
                    },
                ],
            };
        },
        chartOptions() {
            const regularMsList = this.regularMsList;
            const overtimeMsList = this.overtimeMsList;
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: true, position: "top" },
                    title: { display: false },
                    tooltip: {
                        callbacks: {
                            label(ctx) {
                                const idx = ctx.dataIndex;
                                const ms =
                                    ctx.datasetIndex === 0
                                        ? regularMsList[idx]
                                        : overtimeMsList[idx];
                                return `${ctx.dataset.label}: ${formatTimeFromMs(ms)}`;
                            },
                            footer(items) {
                                if (!items.length) return "";
                                const idx = items[0].dataIndex;
                                const total =
                                    (regularMsList[idx] || 0) +
                                    (overtimeMsList[idx] || 0);
                                return `Total: ${formatTimeFromMs(total)}`;
                            },
                        },
                    },
                },
                scales: {
                    x: { stacked: true },
                    y: {
                        stacked: true,
                        beginAtZero: true,
                        title: { display: true, text: "Time" },
                        ticks: {
                            callback: hoursTickToLabel,
                        },
                    },
                },
            };
        },
    },
};
</script>
